var React = require('react');

function Send (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_146","data-name":"Path 146","d":"M1229.894,1254.7l-17.663-8.632,2.217,8.631h15.446Zm-15.446,1.78-2.216,8.544,17.662-8.544Zm-3.088-12.727,22.653,11.036a.913.913,0,0,1,0,1.6l-22.654,10.944c-.554.357-1.266-.267-1.108-.978l2.773-10.77-2.773-10.768c-.158-.712.475-1.423,1.109-1.068Zm-3.563,17.8a.907.907,0,0,1,.792.889.845.845,0,0,1-.79.891h-4.438a.8.8,0,0,1-.792-.891.848.848,0,0,1,.791-.89h4.437Zm1.189-6.856a.8.8,0,0,1,.792.891.85.85,0,0,1-.791.89h-4.358a.849.849,0,0,1-.792-.89.8.8,0,0,1,.792-.891h4.357Zm-1.189-6.941a.9.9,0,0,1,0,1.781h-4.438a.9.9,0,0,1,0-1.781h4.437Z","transform":"translate(-1202.569 -1243.656)","fill":"#2d2c25"}));
}

Send.defaultProps = {"width":"31.92","height":"23.782","viewBox":"0 0 31.92 23.782"};

module.exports = Send;

Send.default = Send;
